module.exports = __webpack_public_path__ + "static/media/Header.299582b5.jpg";